import { Component, CSSProperties, MouseEventHandler } from "react";
import Griddle, { ColumnDefinition, RowDefinition } from "griddle-react";
import styleConfigs from "./style-configs";
import PredefinedComponents from "./predefined-components";
export interface SGridProps {
  columns: (string | [string, string] | [string, string, number])[];
  urlAddress?: string | undefined;
  dataProvider: (
    page: number,
    rows: number
  ) => Promise<{ records: number; rows: any[] }>;
}

interface ISGridButton {
  className: string;
  style?: CSSProperties;
  onClick?: MouseEventHandler<HTMLButtonElement>;
  hasNext?: unknown;
  hasPrevious?: unknown;
}

class SGrid extends Component<SGridProps> {
  state: Readonly<{
    data: any[];
    currentPage: number;
    totalRecords: number;
    pageSize: number;
  }> = { data: [], currentPage: 1, totalRecords: 0, pageSize: 5 };

  changePage = (page: number) => {
    const pageData: { [id: string]: any }[] = [];

    this.props.dataProvider(page, this.state.pageSize).then((data) => {
      console.log("Fetched Data:", data);
      console.log("Columns:", this.props.columns);

      data.rows.forEach((item, index) => {
        pageData[index] = {};

        this.props.columns.forEach((colDef) => {
          if (!Array.isArray(colDef)) return;

          const [columnName, componentKey, columnIndex] = colDef;
          const safeIndex = typeof columnIndex === "number" ? columnIndex : -1;

            if (safeIndex >= 0 && item.cell[safeIndex] !== undefined) {
              let value = item.cell[safeIndex];

              if (componentKey === "ticketStatus") {
                const ticketStatus: Record<number, string> = {
                  1: "ثبت شده",
                  2: "تحویل شده",
                  3: "حذف شده",
                  4: "منقضی",
                };

                value = ticketStatus[value] ?? value;
              }

              pageData[index][columnName] = value;
            }
        });

        if (!pageData[index]["ID"] && item.cell.length > 0) {
          pageData[index]["ID"] = item.cell[0];
        }
      });

      this.setState({
        data: pageData,
        currentPage: page,
        totalRecords: data.records,
      });
    });
  };

  componentDidMount() {
    this.changePage(1);
  }

  render() {
    return (
      <Griddle
        data={this.state.data}
        pageProperties={{
          pageSize: this.state.pageSize,
          currentPage: this.state.currentPage,
          recordCount: this.state.totalRecords,
        }}
        styleConfig={styleConfigs}
        events={{
          onNext: () => this.changePage(this.state.currentPage + 1),
          onPrevious: () => this.changePage(this.state.currentPage - 1),
          onGetPage: this.changePage,
        }}
        components={{
          NextButton: ({
            className,
            style,
            onClick,
            hasNext,
          }: ISGridButton) => (
            <button
              style={style}
              className={className}
              onClick={onClick}
              disabled={!hasNext}
            >
              بعدی
            </button>
          ),
          PreviousButton: ({
            className,
            style,
            onClick,
            hasPrevious,
          }: ISGridButton) => (
            <button
              style={style}
              className={className}
              onClick={onClick}
              disabled={!hasPrevious}
            >
              قبلی
            </button>
          ),
        }}
      >
        <RowDefinition>
          {this.props.columns.map((colDef, index) => {
            let columnName: string = "";
            let customComponent:
              | React.FunctionComponent<any>
              | undefined = undefined;

            if (Array.isArray(colDef)) {
              const [colName, componentKey] = colDef;
              columnName = colName;

              if (componentKey) {
                const ComponentFromPredefined =
                  PredefinedComponents[
                    componentKey as keyof typeof PredefinedComponents
                  ];

                if (ComponentFromPredefined) {
                  customComponent = (props) => (
                    <ComponentFromPredefined
                      {...props}
                      urlAddress={this.props.urlAddress}
                    />
                  );
                }
              }
            } else {
              columnName = colDef;
            }

            return (
              <ColumnDefinition
                key={index}
                id={columnName}
                title={columnName}
                customComponent={customComponent}
              />
            );
          })}
        </RowDefinition>
      </Griddle>
    );
  }
}

export default SGrid;
